import Drift from 'drift-zoom';

$('#product-slider').on('init', function () {
    if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $('#product-slider .cover-photo').each(function () {
            new Drift(this, {
                // showWhitespaceAtEdges: true,
                // containInline: true,
                // boundingBoxContainer: this.parentElement,
                paneContainer: this.parentElement,
            });
        });
    }
}).slick({
    fade: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '#product-carousel',
    responsive: [{
        breakpoint: 768,
        settings: {}
    }]
}).on('afterChange', function (event, slick, currentSlide, nextSlide) {});

$('#product-carousel').on('init', function () {}).slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    // prevArrow: '<button class="arrow-left"><i class="icon-arrow-1-left"></i></button>',
    // nextArrow: '<button class="arrow-right"><i class="icon-arrow-1-right"></i></button>',
    asNavFor: '#product-slider',
    centerMode: false,
    focusOnSelect: true,
    responsive: [{
        breakpoint: 769,
        settings: {
            slidesToShow: 2,
        }
    }]
});